// Mock data for Cornerstone Exim website

export const companyInfo = {
  name: "Cornerstone Exim",
  tagline: "Rooted in Faith, Reaching the world",
  description: "Leading exporter of premium agricultural products from India to international markets",
  email: "info@cornerstoneexim.com",
  emailSecondary: "cornerstoneeximindia@gmail.com",
  phone: "+91 93262 55288",
  whatsapp: "+91 93262 55288",
  address: "A/4, Anamay Co-op Hsg Soc, Kanchan Pushpa, G.B. Road, Thane (W), Maharashtra, India",
  logo: "https://customer-assets.emergentagent.com/job_merchant-cornerstone/artifacts/sohqaidf_Logo%20CS.jpg",
  founder: {
    name: "Komal Chikane",
    experience: [
      { company: "Zepto", role: "Category Manager" },
      { company: "Dunzo", role: "Key Account Manager" },
      { company: "Bounce", role: "Operations" }
    ]
  }
};

export const products = [
  {
    id: 2,
    name: "Fresh Fruits",
    description: "Export-quality fresh fruits including pomegranates, grapes, and seasonal fruits directly from farms.",
    image: "https://images.pexels.com/photos/5677921/pexels-photo-5677921.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "Fruits"
  },
  {
    id: 3,
    name: "Indian Spices",
    description: "Authentic Indian spices with rich aroma and flavor. Including turmeric, cumin, coriander, and exotic spice blends.",
    image: "https://images.unsplash.com/photo-1716816211590-c15a328a5ff0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxzcGljZXN8ZW58MHx8fHwxNzczODQ3NzQ5fDA&ixlib=rb-4.1.0&q=85",
    category: "Spices"
  },
  {
    id: 5,
    name: "Turmeric (Organic) — Fresh, Finger, Flakes & Powder",
    description: "NPOP-certified organic turmeric available as fresh rhizomes, dried fingers, flakes, and vibrant powder with high curcumin content.",
    image: "/images/products/turmeric.webp",
    category: "Organic"
  },
  {
    id: 6,
    name: "Ginger (Organic) — Fresh, Flakes & Powder",
    description: "Premium organic ginger sourced from certified farms, offered fresh, as dried flakes, and as fine aromatic powder.",
    image: "/images/products/ginger.webp",
    category: "Organic"
  },
  {
    id: 7,
    name: "Buckwheat (Organic) — Unhulled & Flour",
    description: "Nutritious organic buckwheat available unhulled and as stone-ground flour. Gluten-free and rich in protein.",
    image: "/images/products/buckwheat.webp",
    category: "Organic"
  },
  {
    id: 8,
    name: "Large Black Cardamom (Organic)",
    description: "Bold, smoky large black cardamom (Badi Elaichi) with intense aroma, hand-picked and naturally dried from organic farms.",
    image: "/images/products/black-cardamom.webp",
    category: "Organic"
  },
  {
    id: 9,
    name: "Coffee Beans Robusta & Arabica (Organic)",
    description: "Bold Robusta and smooth Arabica organic coffee beans grown in shaded plantations, available green and roasted.",
    image: "/images/products/coffee.webp",
    category: "Organic"
  },
  {
    id: 10,
    name: "Cocoa — Fresh & Dried Beans (Organic)",
    description: "Premium organic cocoa available as fresh pods and naturally fermented dried beans with rich chocolate notes.",
    image: "/images/products/cocoa.webp",
    category: "Organic"
  },
  {
    id: 11,
    name: "Nutmeg (Organic) — Dried & Shelled",
    description: "Aromatic organic nutmeg, carefully dried and shelled to preserve its warm, sweet flavor and essential oils.",
    image: "/images/products/nutmeg.webp",
    category: "Organic"
  },
  {
    id: 12,
    name: "Cardamom (Green) (Organic)",
    description: "Fragrant organic green cardamom pods with intense aroma, hand-picked at peak maturity from certified estates.",
    image: "/images/products/green-cardamom.webp",
    category: "Organic"
  },
  {
    id: 13,
    name: "Black Pepper (Organic)",
    description: "Bold organic black peppercorns with high piperine content, sun-dried to deliver sharp, pungent flavor.",
    image: "/images/products/black-pepper.webp",
    category: "Organic"
  }
];

export const features = [
  {
    icon: "Leaf",
    title: "Direct Farm Sourcing",
    description: "We procure directly from farms, ensuring the highest quality and freshness while supporting local farmers."
  },
  {
    icon: "Shield",
    title: "Quality Assurance",
    description: "Rigorous quality checks and certifications to meet international standards and buyer requirements."
  },
  {
    icon: "Globe",
    title: "Global Reach",
    description: "Serving clients across multiple continents with reliable shipping and timely deliveries."
  },
  {
    icon: "Award",
    title: "Certified Excellence",
    description: "ISO certified processes and compliance with international food safety standards."
  }
];

export const process = [
  {
    step: "01",
    title: "Farm Selection",
    description: "We carefully select farms based on quality standards, sustainable practices, and certification requirements."
  },
  {
    step: "02",
    title: "Quality Inspection",
    description: "Multiple quality checks from harvest to packaging ensuring only the best products reach international markets."
  },
  {
    step: "03",
    title: "Processing & Packaging",
    description: "State-of-the-art processing facilities and international standard packaging for maximum freshness."
  },
  {
    step: "04",
    title: "Global Shipping",
    description: "Efficient logistics and shipping partnerships ensuring timely delivery to clients worldwide."
  }
];

export const markets = [
  "Middle East",
  "Europe",
  "Southeast Asia",
  "North America",
  "Africa",
  "Australia"
];

export const certifications = [
  "Spice Board Registration",
  "FSSAI Licensed",
  "Export License Holder",
  "APEDA Registered",
  "Quality Management System"
];

export const stats = [
  { number: "500+", label: "Happy Clients" },
  { number: "25+", label: "Countries Served" },
  { number: "1000+", label: "Tons Exported Annually" },
  { number: "15+", label: "Years Experience" }
];
